import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { IFormStore } from '../interface';
import { Subject } from 'rxjs';

type State = { state: 'idle' | 'invalid' } | { state: 'valid'; data: any };

const initialState: State = { state: 'idle' };

@Injectable()
export class CreditReportRequestStore extends ComponentStore<State> implements IFormStore {
  readonly setStateInvalid = this.updater(() => ({ state: 'invalid' }));
  readonly setDataValid = this.updater<any>((_, data) => ({ state: 'valid', data }));
  readonly dataState$ = this.select(s => (s.state === 'valid' ? s : null));
  readonly submit$ = new Subject<void>();

  constructor() {
    super(initialState);
  }
}
